import apiInstance from "api";

export const PaymentMethodsApiService = {
  getPaymentMethods: async () => {
    return await apiInstance.get(`/financials/payment-methods`);
  },
  addPaymentMethod: async (body) => {
    return await apiInstance.post(`/financials/payment-methods`, body);
  },
  deletePaymentMethod: async (paymentMethodId) => {
    return await apiInstance.delete(`/financials/payment-methods/${paymentMethodId}`);
  },
  markDefaultPaymentMethod: async (paymentMethodId) => {
    return await apiInstance.put(`/financials/payment-methods/${paymentMethodId}`);
  },
};

const FinancialsApiService = {
  getSubscriptionPlan: async (planId) => {
    return await apiInstance.get(`/financials/subscription-plan/${planId}`);
  },
  checkoutCustomSubscription: async (body) => {
    return await apiInstance.post(`/financials/checkout-custom-subscription`, body);
  },
  getCheckoutCustomSubscription: async (subscriptionCode) => {
    return await apiInstance.get(`/financials/checkout-custom-subscription/${subscriptionCode}`);
  },
  getCheckoutDeviceSubscription: async (deviceNumber) => {
    return await apiInstance.get(`/financials/checkout-device-subscription/${deviceNumber}`);
  },
  checkoutDeviceSubscription: async (body) => {
    return await apiInstance.post(`/financials/checkout-device-subscription`, body);
  },
  getCheckoutDetails: async (subscriptionCode) => {
    return await apiInstance.get(`/financials/business/checkout/${subscriptionCode}`);
  },
  getSubscriptionCheckoutDetails: async (subscriptionCode) => {
    return await apiInstance.get(`/financials/subscription-checkout/${subscriptionCode}`);
  },
  // From dashboard app
  subscriptionCheckout: async (body) => {
    return await apiInstance.post(`/financials/subscription-checkout`, body);
  },
  businessCheckout: async (body) => {
    return await apiInstance.post(`/financials/business/checkout`, body);
  },
  getSubscription: async (subscriptionId) => {
    return await apiInstance.get(`/financials/subscription/${subscriptionId}`);
  },
  getTransactions: async (queryParams) => {
    return await apiInstance.get(`/financials/transactions`, {
      params: {
        ...queryParams,
      },
    });
  },
};

export default FinancialsApiService;
